module.exports = __webpack_public_path__ + "static/media/MainHand_3.c28cdc60.jpg";